module.exports = __webpack_public_path__ + "static/media/bunny-lose.dc84cbef.jpg";